import Vuex from 'vuex'
import auth from './modules/auth'
import player from './modules/player'
import fighter from './modules/fighter'
import employees from './modules/employees'
import city from './modules/city'
import championships from './modules/championships'
import matches from './modules/matches'
import battle from './modules/battle'
import hospital from './modules/hospital'
import workers from './modules/workers'
import business from './modules/business'
import production from './modules/production'
import minigames from './modules/minigames'
import gym from './modules/gym'
import specialWorker from './modules/specialWorker'
import tournament from './modules/tournament'
import notification from './modules/notification'
import SoundController from './modules/SoundController'
import Configs from './modules/configs'
import rankings from './modules/rankings'
import chatGlobal from './modules/chatGlobal'
import inventory from './modules/inventory'
import monetization from './modules/monetization'
import revival from './modules/revival'
import statusEffects from './modules/statusEffects'

export default new Vuex.Store({
  modules: {
    auth,
    player,
    fighter,
    employees,
    city,
    championships,
    matches,
    battle,
    hospital,
    workers,
    business,
    production,
    minigames,
    gym,
    specialWorker,
    tournament,
    notification,
    SoundController,
    Configs,
    rankings,
    chatGlobal,
    inventory,
    monetization,
    revival,
    statusEffects
  }
})
